// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"842":"7c30b1b3","997":"60368cc2"}[chunkId] + ".chunk.css";
};